import { Extra, ModalityIncludedExtra } from '../models/types';

export const PACK_SANDWICH_EXTRA_ID = 5;

const SANDWICH_FILLING_LABEL = 'Jamón y Queso';

function normalizeName(value: string): string {
    return value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

export function isPackSandwichExtra(
    extra: Pick<Extra | ModalityIncludedExtra, 'extra_id' | 'extra_name'>
): boolean {
    if (Number(extra.extra_id) === PACK_SANDWICH_EXTRA_ID) {
        return true;
    }
    const name = normalizeName(extra.extra_name);
    return name.includes('pack sandwich') || name.includes('pack sandwish');
}

/** Customer-facing sandwich filling clarification. */
export function formatSandwichFillingLabel(): string {
    return SANDWICH_FILLING_LABEL;
}

/** Customer-facing label for the modality sandwich merienda option. */
export function formatSandwichMeriendaLabel(): string {
    return `Sándwich de ${SANDWICH_FILLING_LABEL}`;
}

/** Override catalog names for customer-facing UI / emails. */
export function formatExtraDisplayName(
    extra: Pick<Extra | ModalityIncludedExtra, 'extra_id' | 'extra_name'>
): string {
    if (isPackSandwichExtra(extra)) {
        return `Pack Sandwich de ${SANDWICH_FILLING_LABEL}`;
    }
    return extra.extra_name;
}
